import { render, staticRenderFns } from "./OffersBlockComponent.vue?vue&type=template&id=4fb34d42&scoped=true"
import script from "./OffersBlockComponent.vue?vue&type=script&lang=js"
export * from "./OffersBlockComponent.vue?vue&type=script&lang=js"
import style0 from "./OffersBlockComponent.vue?vue&type=style&index=0&id=4fb34d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb34d42",
  null
  
)

export default component.exports